"use client";

import { setConsentChoice } from "@/lib/analytics-consent";
import { useAnalyticsConsent } from "@/hooks/use-analytics-consent";
import { Button } from "@/components/ui/button";

export function AnalyticsConsentBanner() {
  const { ready, required, choice } = useAnalyticsConsent();
  if (!ready || !required || choice !== null) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Analytics cookies"
      className="fixed inset-x-4 bottom-4 z-[100] mx-auto max-w-lg rounded-lg border border-border/60 bg-background/95 p-4 shadow-lg backdrop-blur sm:inset-x-auto sm:right-6"
    >
      <p className="text-sm text-foreground">
        We use analytics cookies to see how people find and use Fexr, and to
        credit the person who shared a link with you. Nothing is shared with
        advertisers.{" "}
        <a
          href="https://fexr.io/privacy-policy"
          className="underline underline-offset-2"
        >
          Privacy policy
        </a>
      </p>
      <div className="mt-3 flex justify-end gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setConsentChoice(false)}
        >
          Decline
        </Button>
        <Button size="sm" onClick={() => setConsentChoice(true)}>
          Accept
        </Button>
      </div>
    </div>
  );
}
